// extracted by mini-css-extract-plugin
module.exports = {"segment-counter":"segment-counter--3CQVdJ9peG","segmentCounter":"segment-counter--3CQVdJ9peG","exceeded":"exceeded--3A_LO1l5Us"};